import { useState, useEffect } from "react";
import axios from "../../../../configApi/axiosConfig";
import { APIURL } from "../../../../configApi/apiConfig";
import { ID_PRODUCTO_MOTOS } from "../constants/documentos-bs";

// true si la solicitud es de MOTOS (Cre_SolicitudWeb.idProductos = 10): en ese caso
// se exige además la Papeleta de votación. Se consulta aquí para no depender de
// que la pantalla anterior pase el producto en location.state.
export function useEsSolicitudMotos(idCreSolicitudWeb) {
  const [esSolicitudMotos, setEsSolicitudMotos] = useState(false);

  useEffect(() => {
    if (!idCreSolicitudWeb) return;
    let cancelado = false;
    axios
      .get(APIURL.getConsultaCre_solicitud_web(idCreSolicitudWeb))
      .then((res) => {
        if (!cancelado) setEsSolicitudMotos(Number(res?.data?.idProductos) === ID_PRODUCTO_MOTOS);
      })
      .catch((err) => console.error("Error al consultar el producto de la solicitud:", err));
    return () => {
      cancelado = true;
    };
  }, [idCreSolicitudWeb]);

  return esSolicitudMotos;
}
